import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function TimeIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg width={width || 20} height={height || 20} viewBox="0 0 20 20">
      <circle data-name="Ellipse 131" cx={10} cy={10} r={10} fill="#2f2f2f" />
      <path
        data-name="Path 10032"
        d="M14-3.15a.586.586 0 00.8-.122l.883-1.217a.563.563 0 00-.122-.789l-3.133-2.283v-6.657a.565.565 0 00-.564-.564h-1.5a.565.565 0 00-.564.564V-6.5a.567.567 0 00.23.456z"
        transform="translate(-1.097 18)"
        fill={color || "#fff"}
      />
    </svg>
  );
}
